export type ColorIconSize = "sm" | "default" | "lg";
export const getColorIconSize = (size: ColorIconSize) => {
  switch (size) {
    case "sm":
      return 16;
    case "default":
      return 20;
    case "lg":
      return 24;
    default:
      return 20;
  }
};

export interface ColorIconProps {
  size?: ColorIconSize;
  className?: string;
}
